// src/hooks/useSubscription.js
import { useState, useCallback } from 'react';
import axios                     from 'axios';
import API_BASE                  from '../api/config';

import { PLATFORMS }     from '../constants/platforms';
import { useCachedFetch } from './useCachedFetch';

/* шаблон «пустого» статуса */
const emptyStatus = () => ({
  subscribed   : false,
  endDate      : '',
  maxChannels  : 0,
  channelsUsed : 0,
  byChannel    : {},          // канал → ISO-дата окончания
});

export default function useSubscription() {
  /* всё состояние храним здесь */
  const [subscription, setSubscription] = useState({
    isStreamer : false,
    statusText : 'Загрузка…',
    ...Object.fromEntries(PLATFORMS.map(p => [p.id, emptyStatus()])),
  });

  /* общий кэш на 30 с */
  const cached = useCachedFetch(30_000);

  /**
   * Запрос /subscription/ и раскладка ответа по платформам.
   *  – `endDate` – человекочитаемая дата (dd.mm.yyyy)
   *  – `byChannel` – словарь { 'channelName': '2025-08-31T00:00:00Z', … }
   */
  const checkSubscription = useCallback(
    () => cached('subscription', async () => {
      const jwt = localStorage.getItem('jwt') || '';

      const { data } = await axios.get('/subscription/', {
        headers         : { Authorization: `Bearer ${jwt}` },
        withCredentials : true,
        baseURL         : API_BASE,
      });

      const next = {};
      PLATFORMS.forEach(p => {
        const src = data[p.id] || {};

        /* строим карту «канал → дата окончания» */
        const byChannel = {};
        (src.items || []).forEach(item => {
          (item.channels || []).forEach(ch => {
            byChannel[ch] = item.end_date;
          });
        });

        next[p.id] = {
          subscribed   : Boolean(src.subscribed),
          endDate      : src.end_date
            ? new Date(src.end_date).toLocaleDateString('ru-RU')
            : '',
          maxChannels  : src.max_channels  ?? 0,
          channelsUsed : src.channels_used ?? 0,
          byChannel,
        };
      });

      /* собираем красивый текст для шапки */
      const active = PLATFORMS.filter(p => next[p.id].subscribed);
      const text   = active.length
        ? `Подписан на ${active.map(p => p.label).join(' и ')}`
        : 'Не подписан';

      setSubscription({ ...next, isStreamer: Boolean(data.is_streamer), statusText: text });
      return next;
    }),
    [cached],
  );

  return { subscription, checkSubscription };
}
